const axios = require("axios")

const server_host = "http://localhost:5000/api"
//const server_host = "http://192.168.1.22:5000"
//const server_host = "https://quadapi.arcvisions.com"
//const server_host = "http://documedicl.arcvisions.com:5050"

function set_token(token) {
    return axios.create({
        baseURL: server_host,
        headers: {
            Authorization: 'Bearer ' + token
        }
    })
}

let http_jwt = set_token('')

function update_jwt(token) {
    http_jwt = set_token(token)
}

const http_auth = axios.create({
    baseURL: server_host
})

export { server_host, update_jwt, http_jwt, http_auth }
